import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap'
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'ngbTime',
})
export class NgbTimePipe implements PipeTransform {

    transform(ngbTime: NgbTimeStruct | null, timeString?: string): Date | null {
        if (!ngbTime) {
            if (timeString) {
                return new Date(`1970-01-01T${timeString}`)
            }
            return null
        }
        const date = new Date()
        date.setHours(ngbTime.hour)
        date.setMinutes(ngbTime.minute)
        date.setSeconds(ngbTime.second)
        return date
    }
}
